import { Router, NavigationEnd } from '@angular/router';
import { Injectable, Inject, defineInjectable, inject, NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Declare ga as a function
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';

function Mugan86GoogleAnalyticsComponent_p_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Analytics with ", ctx_r0.analiticsId, " track ID ");
} }
class GoogleAnalyticsService {
    /**
     * create our event emitter to send our data to Google Analytics
     * @param {?} eventCategory Event category to use filt in GA Panel
     * @param {?} eventAction Event action to use filt in GA Panel
     * @param {?=} eventLabel Event label to use filt in GA Panel
     * @param {?=} eventValue Event value ID
     * @return {?}
     */
    eventEmitter(eventCategory, eventAction, eventLabel = null, eventValue = null) {
        ga('send', 'event', {
            eventCategory,
            eventLabel,
            eventAction,
            eventValue
        });
    }
}
GoogleAnalyticsService.ɵfac = function GoogleAnalyticsService_Factory(t) { return new (t || GoogleAnalyticsService)(); };
GoogleAnalyticsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: GoogleAnalyticsService, factory: GoogleAnalyticsService.ɵfac, providedIn: 'root' });
/** @nocollapse */ GoogleAnalyticsService.ngInjectableDef = defineInjectable({ factory: function GoogleAnalyticsService_Factory() { return new GoogleAnalyticsService(); }, token: GoogleAnalyticsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleAnalyticsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GaConfigService {
    /**
     * @param {?} analytics
     */
    constructor(analytics) {
        this.analytics = analytics;
        this.analiticsId = this.analytics.analyticsId;
        this.showLog = this.analytics.showLog;
        if (this.showLog) {
            console.log('Analytics ID: ', this.analiticsId);
        }
    }
}
GaConfigService.ɵfac = function GaConfigService_Factory(t) { return new (t || GaConfigService)(ɵngcc0.ɵɵinject('analyticsConfig')); };
GaConfigService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: GaConfigService, factory: GaConfigService.ɵfac, providedIn: 'root' });
/** @nocollapse */
GaConfigService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['analyticsConfig',] }] }
];
/** @nocollapse */ GaConfigService.ngInjectableDef = defineInjectable({ factory: function GaConfigService_Factory() { return new GaConfigService(inject("analyticsConfig")); }, token: GaConfigService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GaConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['analyticsConfig']
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Mugan86GoogleAnalyticsComponent {
    /**
     * @param {?} gaConfig
     * @param {?} router
     */
    constructor(gaConfig, router) {
        this.gaConfig = gaConfig;
        this.router = router;
        this.showLog = this.gaConfig.showLog;
        this.analiticsId = this.gaConfig.analiticsId;
    }
    // https://stackoverflow.com/a/45917264
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const body = (/** @type {?} */ (document.body));
        /** @type {?} */
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.innerHTML = `
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', '${this.gaConfig.analiticsId}', 'auto');`;
        body.appendChild(script);
    }
    /**
     * @return {?}
     */
    ngAfterContentChecked() {
        // subscribe to router events and send page views to Google Analytics
        this.router.events.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            if (event instanceof NavigationEnd) {
                if (window !== undefined) {
                    ((/** @type {?} */ (window))).ga('set', 'page', event.urlAfterRedirects);
                    ((/** @type {?} */ (window))).ga('send', 'pageview');
                }
            }
        }));
    }
}
Mugan86GoogleAnalyticsComponent.ɵfac = function Mugan86GoogleAnalyticsComponent_Factory(t) { return new (t || Mugan86GoogleAnalyticsComponent)(ɵngcc0.ɵɵdirectiveInject(GaConfigService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router)); };
Mugan86GoogleAnalyticsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Mugan86GoogleAnalyticsComponent, selectors: [["mga-google-analytics"]], decls: 1, vars: 1, consts: [[4, "ngIf"]], template: function Mugan86GoogleAnalyticsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, Mugan86GoogleAnalyticsComponent_p_0_Template, 2, 1, "p", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLog);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
/** @nocollapse */
Mugan86GoogleAnalyticsComponent.ctorParameters = () => [
    { type: GaConfigService },
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Mugan86GoogleAnalyticsComponent, [{
        type: Component,
        args: [{
                selector: 'mga-google-analytics',
                template: `
    <p *ngIf="showLog">
      Analytics with {{ analiticsId }} track ID
    </p>
  `
            }]
    }], function () { return [{ type: GaConfigService }, { type: ɵngcc1.Router }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Mugan86GoogleAnalyticsModule {
    /**
     * @param {?} analytics
     * @return {?}
     */
    static forRoot(analytics) {
        return {
            ngModule: Mugan86GoogleAnalyticsModule,
            providers: [
                GaConfigService,
                {
                    provide: 'analyticsConfig',
                    useValue: analytics
                }
            ]
        };
    }
}
Mugan86GoogleAnalyticsModule.ɵfac = function Mugan86GoogleAnalyticsModule_Factory(t) { return new (t || Mugan86GoogleAnalyticsModule)(); };
Mugan86GoogleAnalyticsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: Mugan86GoogleAnalyticsModule });
Mugan86GoogleAnalyticsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Mugan86GoogleAnalyticsModule, { declarations: function () { return [Mugan86GoogleAnalyticsComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [Mugan86GoogleAnalyticsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Mugan86GoogleAnalyticsModule, [{
        type: NgModule,
        args: [{
                declarations: [Mugan86GoogleAnalyticsComponent],
                imports: [
                    CommonModule
                ],
                exports: [Mugan86GoogleAnalyticsComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { GoogleAnalyticsService, Mugan86GoogleAnalyticsComponent, Mugan86GoogleAnalyticsModule, GaConfigService as ɵa };

//# sourceMappingURL=mugan86-ng-google-analytics.js.map